import { Box } from 'braid-design-system';

import { usePaymentSuccessPostListing } from '../../../hooks/usePaymentSuccessPostListing';

import { GenericRepostError } from './components/GenericRepostError';
import { GenericRepostLoading } from './components/GenericRepostLoading';
import { GenericRepostSuccess } from './components/GenericRepostSuccess';

interface GenericRepostPaymentSuccessProps {
  clientId: string;
  listingId: string;
}

export const GenericRepostPaymentSuccess = (
  props: GenericRepostPaymentSuccessProps,
) => {
  const postListingByIdStatus = usePaymentSuccessPostListing(props.listingId);

  if (
    postListingByIdStatus.kind === 'idle' ||
    postListingByIdStatus.kind === 'loading'
  ) {
    return (
      <Box data={{ testid: 'generic-repost-payment-success-loading' }}>
        <GenericRepostLoading />
      </Box>
    );
  }

  if (postListingByIdStatus.kind === 'error') {
    return (
      <Box data={{ testid: 'generic-repost-payment-success-error' }}>
        <GenericRepostError />
      </Box>
    );
  }

  return (
    <Box data={{ testid: 'generic-repost-payment-success' }}>
      <GenericRepostSuccess
        clientId={props.clientId}
        listingId={props.listingId}
      />
    </Box>
  );
};
